import { Navigate, useLocation } from "react-router-dom";
import { ROUTE_FLAGS, type RouteFlagKey } from "@/config/routeFlags";
import { useRouteFlag } from "@/contexts/RouteFlagContext";

interface FlagRouteProps {
  flag: RouteFlagKey;
  children: React.ReactNode;
  /** Override the configured fallback destination. */
  fallbackPath?: string;
}

/**
 * Renders children only while the route flag is enabled.
 * When disabled, redirects to the flag's fallback path so links never 404.
 */
export function FlagRoute({ flag, children, fallbackPath }: FlagRouteProps) {
  const enabled = useRouteFlag(flag);
  const location = useLocation();
  const target = fallbackPath ?? ROUTE_FLAGS[flag].fallbackPath;

  if (!enabled && location.pathname !== target) {
    return <Navigate to={target} replace />;
  }

  return <>{children}</>;
}
